import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { timesheetEndpoints } from '@/lib/api/endpoints';
import { timesheetKeys } from '@/lib/queryKeys';
import type { TimesheetPeriodParams, TimesheetPeriodResponse } from '@/types/timesheet';

/**
 * Per-technician × pay-period aggregation grid (hours per day, regular/OT/travel
 * split, approval state) from the operations service.
 */
export function useTimesheetPeriod(params: TimesheetPeriodParams) {
  return useApiQuery<TimesheetPeriodResponse>({
    queryKey: timesheetKeys.period(params),
    queryFn: () =>
      apiGet<TimesheetPeriodResponse>(operationsClient, timesheetEndpoints.period(), { params }),
    enabled: Boolean(params.periodStart && params.periodEnd),
  });
}
